import React from 'react'
import { m } from 'framer-motion'
import { CalendarCheck, Car, MapPin, PhoneCall, Utensils } from 'lucide-react'
import { useTheme } from '../../../context/ThemeContext'
import { useLanguage } from '../../../context/LanguageContext'
import { PHONE_LINK, NAVER_BOOKING_URL, NAVER_MAP_URL } from '../../../constants/contact'
import { trackCtaClick } from '../../../utils/analytics'

const LocalIntentSection: React.FC = () => {
    const { theme } = useTheme()
    const { t } = useLanguage()

    return (
        <section className={`restaurant-local-intent theme-${theme.mode}`} aria-labelledby="local-intent-title">
            <div className="restaurant-local-intent-container">
                <m.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="restaurant-local-intent-copy"
                >
                    <span className="restaurant-local-intent-label">{t('localIntent.label')}</span>
                    <h2 id="local-intent-title" className="restaurant-local-intent-title">
                        {t('localIntent.title')}
                    </h2>
                    <p className="restaurant-local-intent-description">
                        {t('localIntent.description')}
                    </p>
                </m.div>

                <div className="restaurant-local-intent-grid">
                    <m.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.1 }}
                        className="restaurant-local-intent-card"
                    >
                        <MapPin size={22} />
                        <strong>{t('localIntent.locationLabel')}</strong>
                        <span>{t('localIntent.locationValue')}</span>
                    </m.div>
                    <m.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.16 }}
                        className="restaurant-local-intent-card"
                    >
                        <Utensils size={22} />
                        <strong>{t('localIntent.menuLabel')}</strong>
                        <span>{t('localIntent.menuValue')}</span>
                    </m.div>
                    <m.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.22 }}
                        className="restaurant-local-intent-card"
                    >
                        <Car size={22} />
                        <strong>{t('localIntent.parkingLabel')}</strong>
                        <span>{t('localIntent.parkingValue')}</span>
                    </m.div>
                </div>

                <div className="restaurant-local-intent-actions">
                    <a href={PHONE_LINK} className="restaurant-local-intent-action restaurant-local-intent-phone" onClick={() => trackCtaClick('call', 'local_intent')}>
                        <PhoneCall size={18} />
                        {t('localIntent.phoneAction')}
                    </a>
                    <a href={NAVER_BOOKING_URL} target="_blank" rel="noopener noreferrer" className="restaurant-local-intent-action restaurant-local-intent-reserve" onClick={() => trackCtaClick('reserve', 'local_intent')}>
                        <CalendarCheck size={18} />
                        {t('localIntent.reserveAction')}
                    </a>
                    <a href={NAVER_MAP_URL} target="_blank" rel="noopener noreferrer" className="restaurant-local-intent-action restaurant-local-intent-map" onClick={() => trackCtaClick('map', 'local_intent')}>
                        <MapPin size={18} />
                        {t('localIntent.directionsAction')}
                    </a>
                </div>
            </div>
        </section>
    )
}

export default LocalIntentSection
